import { createAction } from '@reduxjs/toolkit';

export const fetchProposal = createAction('metrics/proposal');
export const fetchMetrics = createAction('metrics/metrics');
export const fetchSendHistory = createAction('metrics/sendHistory');
export const fetchCurrentSessionData = createAction('metrics/currentSessionData');
